export default "__VITE_PUBLIC_ASSET__194c2421__"